import { useState } from "react";
import { Button, Dialog } from "@jkast90/kast-common/ui";
import UserSelector from "../../../profile/components/UserSelector";

const FORM_ID = "invite-form";

interface InviteDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (invitedUserIds: number[]) => void;
  eventTitle: string;
  currentInvites: number[];
}

export default function InviteDialog({
  open,
  onClose,
  onSave,
  eventTitle,
  currentInvites,
}: InviteDialogProps) {
  const [selectedUserIds, setSelectedUserIds] =
    useState<number[]>(currentInvites);

  // Reload the current invites whenever the dialog opens or they change,
  // during render rather than in an effect.
  const [prev, setPrev] = useState({ open, currentInvites });
  if (prev.open !== open || prev.currentInvites !== currentInvites) {
    setPrev({ open, currentInvites });
    if (open) {
      setSelectedUserIds(currentInvites);
    }
  }

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    onSave(selectedUserIds);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Invite to ${eventTitle}`}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" type="submit" form={FORM_ID}>
            Save Invites
          </Button>
        </>
      }
    >
      <form id={FORM_ID} onSubmit={handleSubmit}>
        <UserSelector
          selectedUserIds={selectedUserIds}
          onChange={setSelectedUserIds}
          label="Select Family Members to Invite"
        />
      </form>
    </Dialog>
  );
}
